import numeral from 'numeral'

const formatCurrency = (
  price: string | number,
  cents = true,
  showSymbol = true
) => {
  let value = ''

  if (cents && price) {
    value = numeral(price).format('0,0.00')
  } else if (!cents && price) {
    value = numeral(price).format('0,0')
  }

  if (showSymbol) {
    return `$${value}`
  }

  return value
}
export default formatCurrency
